export enum OPTIONS_CONTENT_TYPE {
  MUSIC = 'music',
  PODCAST = 'podcast',
  ARTWORK = 'artwork',
  USER_IMAGE = 'user_image',
  PLAYLIST_IMAGE = 'playlist_image',
  PLAYLIST_TITLE = 'playlist_title',
  PLAYLIST_DESCRIPTION = 'playlist_description',
  ARTIST_PROFILE_IMAGE = 'artist_profile_image',
  ARTIST_BANNER_IMAGE = 'artist_banner_image',
  ARTIST_GALLERY_IMAGE = 'artist_gallery_image',
  ARTIST_BIO_TEXT = 'artist_bio_text',
  ARTIST_PICK_TEXT = 'artist_pick_text',
  ARTIST_MERCHANDISE = 'artist_merchandise',
  NOW_PLAYING = 'now_playing',
  OTHER = 'other',
  AUDIOBOOK = 'audiobook',
  ARTIST_VIDEO_VIDEO = 'artist_video_video',
  ARTIST_VIDEO_TITLE = 'artist_video_title',
  ARTIST_VIDEO_AUDIO = 'artist_video_audio',
  QUESTION_TEXT = 'question_text',
  RESPONSE_TEXT = 'response_text',
  POLL_QUESTION_TEXT = 'poll_question_text',
  POLL_OPTIONS_TEXT = 'poll_options_text',
}

export const USE_LABEL_FROM_TRANSLATION_PREFIX: string = '_label';

// Types for which we should fetch associated content from tintin
export const ASSOCIATED_CONTENT_TYPES: Set<OPTIONS_CONTENT_TYPE> = new Set([
  OPTIONS_CONTENT_TYPE.ARTIST_BANNER_IMAGE,
  OPTIONS_CONTENT_TYPE.ARTIST_GALLERY_IMAGE,
  OPTIONS_CONTENT_TYPE.ARTIST_PROFILE_IMAGE,
]);

// Types that should contain array of associated content elements.
// For now these are all artist images, but that might change.
export const ASSOCIATED_CONTENT_PRESENCE_REQUIRED: Set<OPTIONS_CONTENT_TYPE> = new Set([
  OPTIONS_CONTENT_TYPE.ARTIST_BANNER_IMAGE,
  OPTIONS_CONTENT_TYPE.ARTIST_GALLERY_IMAGE,
  OPTIONS_CONTENT_TYPE.ARTIST_PROFILE_IMAGE,
]);

// Types that should display the image chooser.
export const ASSOCIATED_CONTENT_IMAGE_TYPES: Set<OPTIONS_CONTENT_TYPE> = new Set([
  OPTIONS_CONTENT_TYPE.ARTIST_BANNER_IMAGE,
  OPTIONS_CONTENT_TYPE.ARTIST_GALLERY_IMAGE,
  OPTIONS_CONTENT_TYPE.ARTIST_PROFILE_IMAGE,
]);

export enum ASSOCIATED_CONTENT_ERRORS {
  NON_EXISTENT_ASSOCIATED_CONTENT = 'form_associated_content_has_non_existent_content_error',
  NON_EXISTENT_CONTENT = 'form_associated_content_non_existent_content_error',
  CONTENT_REQUEST_ERROR = 'form_associated_content_request_error',
  GENERIC_ERROR = 'form_generic_error',
}

export enum Platform {
  IOS = 'ios',
  ANDROID = 'android',
  LIVE_APP_IOS = 'live-app-ios',
  LIVE_APP_ANDROID = 'live-app-android',
  DESKTOP = 'desktop',
  DESKTOP_WEB = 'desktop-web',
}
